import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ChatPanel } from '@hero/web-components';
import { usePageContext } from '@hero/web-context';

/**
 * Full-page AI assistant surface (`/ai`). The same `<ChatPanel layout="page" />`
 * is reused inside the floating launcher so we ship one source of truth for the
 * chat UI; this page simply hosts it edge-to-edge in the dashboard content
 * area.
 *
 * Two presentation tweaks vs. just dropping the panel into the layout:
 *
 * 1. **Negative margins** counteract the `<main>` padding (`px-4 py-5 sm:px-6`
 *    in `DashboardLayout`) so the brand header runs to the screen edges and
 *    the page truly feels like a homepage replacement, not a card-in-a-card.
 * 2. **Page name** is set to "Hero AI" via `usePageContext` so the topbar
 *    breadcrumb shows the current surface instead of the previous page's
 *    title (which was leaking through as "Home").
 *
 * Long-term plan: this page is slated to grow into the carrier-dashboard
 * homepage once the assistant graduates from staging — see
 * `docs/ai/architecture.md`.
 */
export default function AIAgentPage() {
  const { t } = useTranslation('m-agent');
  const { setPageName } = usePageContext();

  useEffect(() => {
    setPageName(t('header.title', 'Hero AI'));
  }, [setPageName, t]);

  return (
    <div className="-mx-4 -my-5 sm:-mx-6 h-[calc(100vh-80px)] w-[calc(100%+2rem)] sm:w-[calc(100%+3rem)] flex flex-col bg-white">
      <ChatPanel layout="page" />
    </div>
  );
}
